<template>
  <div class="new_info">
    <div class="justify">
      <div class="title col-sm-9 col-md-11 col-lg-10">
        <h4>更新情報</h4>
        <p>
          - トップページにガチャ作成手順を掲載しました<br>
          - 投稿したガチャの再編集が可能になりました
          <!-- <br> -->
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// import router from '@/router'

export default {
  methods: {
  }
}
</script>

<style scoped>
@import '../css/common.css';

.new_info {
  padding-left: 5px;
  padding-right: 5px;
  padding-bottom: 10px;
}
.new_info > div > .title {
  background-color: rgb(246, 238, 241);
  padding: 10px;
  border-radius: 10px;
}
.new_info > div > .title > h4 {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 800;
}
.new_info > div > .title > p {
  font-size: 14px;
  margin-bottom: 0px;
}
</style>